import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ITag } from '../types/ITag';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetTagsParams extends IGetItemsParams {
}

export interface IGetTagsResult extends IGetItemsResult {
  tags: ITag[];
}

export class GetTagsRequest extends Request<IGetTagsParams, IGetTagsResult> {
  constructor(params: IGetTagsParams) {
    super('getTags', params);
  }
}
